import { create } from "zustand/react";
import { useShallow } from "zustand/react/shallow";

interface UiPreferencesStore {
  state: string;
  searchKeyword: string;
  actions: {
    setSearchKeyword: (keyword: string) => void;
    unMount: () => void;
    setState: (state: string) => void;
  };
}

const defaultUiPreferencesStoreData = {
  state: "active",
  searchKeyword: "",
  selectedUserId: undefined,
  selectedBotId: undefined,
};

const useUiPreferencesStore = create<UiPreferencesStore>((set) => ({
  ...defaultUiPreferencesStoreData,
  actions: {
    setSearchKeyword: (keyword) =>
      set(() => ({
        searchKeyword: keyword,
      })),
    unMount: () =>
      set(() => ({
        ...defaultUiPreferencesStoreData,
      })),
    setState: (state) =>
      set(() => ({
        state,
      })),
  },
}));

export const useUiPreferencesData = () =>
  useUiPreferencesStore(
    useShallow((state) => ({
      state: state.state,
      searchKeyword: state.searchKeyword,
    })),
  );

export const useUiPreferencesActions = () =>
  useUiPreferencesStore((state) => state.actions);
